import { Capacitor, registerPlugin } from '@capacitor/core';

export interface SystemBarsPlugin {
  applyTheme(options: { color: string; lightStatusBarAppearance: boolean }): Promise<void>;
}

const SystemBarsNative = registerPlugin<SystemBarsPlugin>('SystemBars');

export async function applyNativeSystemBars(
  color: string,
  lightStatusBarAppearance: boolean
): Promise<void> {
  if (Capacitor.getPlatform() !== 'android') return;
  await SystemBarsNative.applyTheme({ color, lightStatusBarAppearance });
}
